<template>
  <div id="app" class="wrap">

  	<cHeader />
  	
  	<div class="head">
  		<img src="./images/361.png" style="display: block;width: 100%;" />
  	</div>
  	
  	<div class="top">
  		<img src="./images/title-icon.png" class="title-icon" />
  		<img src="./images/title-tip.png" class="title-tip" />

  		<div class="top-list-wrap top-phone-list-wrap">
  			<div class="title-text">缓吐舒适进阶</div>
  			<div class="top-list-con relative">
  				<img src="" :data-lazy='require("./images/362.png")' class="top-list-img" />
  				<div class="color-151 top-list-name">青梅饼</div>
  				<div class="top-list-tip">无核更酸爽</div>
  				<div class="top-list-en-tip">ORIED PLUM</div>
  			</div>
  			<img src="" :data-lazy='require("./images/icon1.png")' class="top-list-icon"/>
  		</div>
  		<div class="top-list-wrap top-phone-list-wrap">
  			<div class="top-list-con relative">
  				<img src="" :data-lazy='require("./images/363.png")' class="top-list-img" />
  				<div class="color-151 top-list-name">青梅球</div>
  				<div class="top-list-tip">酸甜更开胃</div>
  				<div class="top-list-en-tip">PLUM BALLS</div>
  			</div>
  			<img src="" :data-lazy='require("./images/icon2.png")' class="top-list-icon top-list-icon-next"/>
  		</div>
  		<div class="top-list-wrap top-phone-list-wrap">
  			<div class="top-list-con relative">
  				<img src="" :data-lazy='require("./images/364.png")' class="top-list-img" />
  				<div class="color-151 top-list-name">青梅浆</div>
  				<div class="top-list-tip">酸爽会回甘</div>
  				<div class="top-list-en-tip">PLUM PULP</div>
  			</div>
  			<img src="" :data-lazy='require("./images/icon3.png")' class="top-list-icon top-list-icon-next"/>
  		</div>
  		<div class="top-list-wrap top-phone-list-wrap">
  			<div class="top-list-con relative">
  				<img src="" :data-lazy='require("./images/365.png")' class="top-list-img top-list-img-last" />
  				<div class="color-151 top-list-name">青梅精</div>
  				<div class="top-list-tip">便携强升级</div>
  				<div class="top-list-en-tip">PLUM ESSENCE</div>
  			</div>
  			<img src="" :data-lazy='require("./images/icon4.png")' class="top-list-icon top-list-icon-next top-list-icon-end"/>
  		</div>
  		
  		<div class="color-255 t-center">
  			<div class="relative">
  				<div class="color-151 comment-title">孕妈妈真实好评</div>
  				<div class="comment-line"></div>
  			</div>
  			<div class="comment-en">TRUE PRAISE</div>
  			<div class="comment-en">FROM PREGNANT MQTHERS</div>
  		</div>
  		<img src="" :data-lazy='require("./images/366.png")' class="comment-img"/>
  	</div>
  	
  	<div class="top bottom">
  		<img src="./images/title-icon1.png" class="title-icon" />
  		<img src="./images/title-tip.png" class="title-tip" />
  		<div class="top-list-wrap bottom-list-wrap relative">
  			<div class="top-list-con bottom-list-con relative">
  				<img src="" :data-lazy='require("./images/icon10.png")' class="bottom-list-img" />
  				<div class="color-151 bottom-list-name">多维小酸弹</div>
  				<div class="bottom-list-tip">富含叶酸和多种维生素</div>
  				
  				<div class="bottom-more-info flex-align-center flex-between">
  					<div class="flex-align-center phone-sty">
  						<div class="flex-align-center">
  							<div class="clear"><img src="./images/icon14.png" class="f-left"/></div>
								<div class="color-255 font-26 mg-l-10 phone-text">缓解早孕反应</div>
  						</div>
							<div class="flex-align-center mg-l-30 pd-l-30 next-text">
  							<img src="./images/icon15.png" style="display: block;"/>
								<div class="color-255 font-26 mg-l-10 phone-text">助力胎儿早期发育</div>
  						</div>
  					</div>
  					<div class="font-20 color-151 phone-text-en">EARLY STAGE</div>
  				</div>
  				
  			</div>
  			
  			<div class="bottom-list-icon">
  				<div>孕护早期</div>
  				<div class="color-151">(1-12周)</div>
  				<div class="bottom-list-line"></div>
  			</div>
  		</div>
  		<div class="top-list-wrap bottom-list-wrap">
  			<div class="top-list-con bottom-list-con relative">
  				<img src="" :data-lazy='require("./images/icon11.png")' class="bottom-list-img" />
  				<div class="color-151 bottom-list-name">五黑能量球</div>
  				<div class="bottom-list-tip">高钙、高铁、高蛋白质</div>
  				
  				
  				<div class="bottom-more-info flex-align-center flex-between">
  					<div class="flex-align-center phone-sty">
  						<div class="flex-align-center">
  							<div class="clear"><img src="./images/icon14.png" class="f-left"/></div>
								<div class="color-255 font-26 mg-l-10 phone-text">补充孕妈全面营养</div>
  						</div>
							<div class="flex-align-center mg-l-30 pd-l-30 next-text">
  							<img src="./images/icon15.png" style="display: block;"/>
								<div class="color-255 font-26 mg-l-10 phone-text">助力宝宝快速成长</div>
  						</div>
  					</div>
  					<div class="font-20 color-151 phone-text-en">METAPHASE</div>
  				</div>
  				
  			</div>
  			<div class="bottom-list-icon">
  				<div>孕护中期</div>
  				<div class="color-151">(13-27周)</div>
  				<div class="bottom-list-line"></div>
  			</div>
  		</div>
  		<div class="top-list-wrap bottom-list-wrap">
  			<div class="top-list-con bottom-list-con relative">
  				<img src="" :data-lazy='require("./images/icon12.png")' class="bottom-list-img" />
  				<div class="color-151 bottom-list-name">高纤小金果</div>
  				<div class="bottom-list-tip">高膳食纤维、高蛋白、高钙</div>
  				<div class="bottom-more-info flex-align-center flex-between">
  					<div class="flex-align-center phone-sty">
  						<div class="flex-align-center">
  							<div class="clear"><img src="./images/icon14.png" class="f-left"/></div>
								<div class="color-255 font-26 mg-l-10 phone-text">缓解后期便秘</div>
  						</div>
							<div class="flex-align-center mg-l-30 pd-l-30 next-text">
  							<img src="./images/icon15.png" style="display: block;"/>
								<div class="color-255 font-26 mg-l-10 phone-text">助力宝宝后期发育</div>
  						</div>
  					</div>
  					<div class="font-20 color-151 phone-text-en">LATER STAGE</div>
  				</div>
  			</div>
  			<div class="bottom-list-icon">
  				<div>孕护后期</div>
  				<div class="color-151">(28-40周)</div>
  			</div>
  		</div>
  		
  	</div>
  	
  	<cFooter />
  	
  </div>
</template>

<script>

let that;
import cHeader from '../../components/cHeader.vue';
import cFooter from '../../components/cFooter.vue';


export default {
  name: 'App',
  data() {
	  return {
	  	
	  }
	},
	components:{cHeader,cFooter},
  mounted() {
	  this.$nextTick(function () {
	  	that = this;
			that.$utils.imgLazy();
			that.$utils.animationLazy();
	  })
	},
	methods:{
		
	}
}
</script>

<style type="text/css">
	
</style>
<style scoped="scoped">
.top{background: url("./images/bg-img.png") no-repeat top left;background-size: 100% auto;
	padding:430px 0 130px 0;background-color: rgb(243,241,233);position: relative;}
.bottom{background-color: rgb(243,241,233);}

.title-icon{position: absolute;right: 15%;top: 4%;}
.title-tip{position: absolute;left: 15%;top: 4%;}
.title-text{font-size: 35px;position: absolute;left: 0;top: -50px;color: #ac6f33;}

.top-list-wrap{width: 1000px;height: 275px;position: relative;padding-left: 340px;
margin: auto;margin-bottom: 190px;}
.top-list-con{width: 100%;height: 100%;background: rgb(252,249,245);position: relative;
box-shadow: 0 6px 30px 6px rgba(0,0,0,0.15);border-radius: 20px;
text-indent: 100px;padding-top: 35px;}

.top-list-name{font-size: 60px;font-weight: bold;}
.top-list-tip{font-size: 36px;color: #ae733a;border-bottom:1px solid;
display: inline-block;padding: 20px 130px 20px 0;margin-left: 100px;text-indent: 0;}
.top-list-en-tip{font-size: 20px;color: #ae733a;margin-top: 20px;}
.top-list-img{position: absolute;right: 10px;top: -80px;}
.top-list-img-last{top: -120px;right: 40px}

.top-list-icon{position: absolute;left: 0;top: 0;}
.top-list-icon-next{top: -90px;}

.comment-title{background: rgb(243,241,233);padding: 0 50px;font-size: 60px;display: inline-block;
position: relative;z-index: 2;}
.comment-line{position: absolute;left: 50%;top: 50%;transform:translate(-50%,-50%);z-index: 1;
width: 60%;height: 2px;background: rgb(136,87,41);}
.comment-en{font-size: 26px;line-height: 42px;}
.comment-img{display: block;margin: auto;}

.bottom-list-img{position: absolute;right: -70px;top: -80px;}
.bottom-list-tip{font-size: 30px;color: #ae733a;
padding: 20px 130px 20px 0;}
.bottom-list-wrap{height: 312px;}
.bottom-list-icon{position: absolute;left: 0;top: 50%;
transform: translateY(-50%);
width: 260px;height: 100px;color: white;font-size: 40px;line-height: 80px;
text-align: center;background: url("./images/icon13.png") no-repeat center;
background-size: 100% 100%;}
.bottom-list-con{text-indent: 60px;}
.bottom-list-name{font-size: 54px;font-weight: bold;}
.bottom-more-info{width: 90%;height: 110px;background: rgb(221,192,156);
position: absolute;left: 0;bottom: 0;border-radius: 0 0 20px 20px;
text-indent: 0;padding: 0 5%;}

.bottom-list-line{border-left: 3px dashed rgb(187,142,102);position: absolute;left:48%;top: 180px;
height: 300px;}

	@media screen and (max-width: 1600px) {
		.top{zoom: 0.85;}
	}
	@media screen and (max-width: 1350px) {
		.top{zoom: 0.7;}
	}
	@media screen and (max-width: 800px) {
		.top{padding: 200px 0 40px 0;}
		.bottom{padding: 140px 0 40px 0;overflow: hidden;}
		.top-list-icon{/*display: none;*/width: auto;height: 150%;top: 0;}
		.top-list-con{text-indent:50px;}
		.top-list-wrap{width: 90%;height:170px;padding-left:0;margin-bottom:140px;}
		.top-phone-list-wrap{width: 70%; padding-left: 25%;margin-bottom: 120px;}
		.top-phone-list-wrap .top-list-con{padding-top: 25px;}
		.top-list-icon-next{height: 176%;top: -30%;}
		.top-list-icon-end{height: 155%;}
		.top-list-img{width: 50%;top: -50px;}
		.top-list-img-last{width: 65%;top: -60px}
		.top-list-name{font-size: 28px;}
		.top-list-tip{font-size: 14px;margin-left:50px}
		.top-list-en-tip{font-size: 14px;}


		.bottom-list-wrap{width: 75%;margin-left: 23%;}
		.bottom-list-img{width: 70%;top: -20px;right: -30px;}
		.bottom-list-icon{zoom: 0.4;left: -32%;}
		.bottom-list-con{text-indent: 20px;}
		.bottom-list-name{font-size: 22px;}
		.bottom-list-tip{font-size: 14px;padding:10px 0 0 0}
		.bottom-more-info{height: 80px;}
		.bottom-more-info .phone-sty{display: block;}
		.bottom-more-info .phone-sty img{width: 20px;}
		.bottom-more-info .phone-text{font-size: 16px;}
		.bottom-more-info .next-text{margin-left: 0;padding-left: 0;margin-top: 10px;}
		.bottom-more-info .phone-text-en{font-size: 16px;}
		
		.comment-title{font-size: 24px;}
		.comment-img{width: 100%;}
		.comment-line{width: 88%;height: 1px;}
		.bottom-list-line{height: 570px;}
  	
  	.title-icon{position: absolute;right: 5%;top: 2%;width: 50%;}
		.title-tip{position: absolute;left: 5%;top: 2%;width: 20%;}
		.title-text{font-size: 24px;}
		.comment-en{font-size: 18px;line-height: 32px;}
	}
</style>
